import { Breakpoint } from '@mui/system';

export const MAIN_BREAKPOINT: Breakpoint = 'lg';
